<template>
  <span class="badge" :class="enabled ? 'badge-on' : 'badge-off'">
    <span class="badge-dot"></span>
    {{ enabled ? $t('statusLabel.enabled') : $t('statusLabel.disabled') }}
  </span>
</template>

<script>
export default {
  name: 'ShoplazzaAppStatusBadge',
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.badge-on {
  background: $green-light;
  color: $green-text;

  .badge-dot {
    background: $green;
  }
}

.badge-off {
  background: #f3f4f6;
  color: $ink-4;

  .badge-dot {
    background: #d1d5db;
  }
}
</style>
